module.exports = __webpack_public_path__ + "media/images/icon_place-e3425d860a99992e7c4226ddf260e97f.svg";